import { inject, Injectable, signal, WritableSignal } from '@angular/core';
import { take } from 'rxjs';
import { FraudService } from '../../api/services/fraud.service';
import { ProjectSetting } from '../../api/models/fraud.models';

@Injectable({
  providedIn: 'root'
})
export class ProjectSettingsService {
  public readonly settings: WritableSignal<ProjectSetting | undefined> = signal<ProjectSetting | undefined>(undefined);

  private readonly _fraudService: FraudService = inject(FraudService);

  load(): void {
    this._fraudService.getProjectSetting().pipe(take(1)).subscribe({
      next: (settings: ProjectSetting) => this.settings.set(settings)
    });
  }
}
